import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import API from "../../../utils/API";
import RichTextEditor from '../../../views/pages/components/richTextEditor';

import TabsContainer from "../../../components/views/TabsContainer";
import InputField from "../../../components/inputs/inputField";
import SelectField from "../../../components/inputs/selectField";
import ColorField from "../../../components/inputs/colorField";
import PagePreviewFrame from "../../../views/pages/components/pagePreviewFrame";
import ToggleField from "../../../components/inputs/toggleField";
import SectionHeader from "../../../components/views/SectionHeader";
import SectionFooter from "../../../components/views/SectionFooter";
import FieldModal from "../../../components/modals/fieldModal";
import IconChooserBox from "../../../components/inputs/iconChooserBox";
import FileUploadInputBox from "../../../components/inputs/fileUploadInputBox";
import FileChooserPreview from "../../../components/inputs/fileChooserPreview";
import FilesUploaderModal from "../../../components/files/filesUploaderModal";
import TextAreaField from "../../../components/inputs/textAreaField";
import Joyride from 'react-joyride';
import tutorials from "../../../layouts/components/tutorials";

const ENV =
	process.env.NODE_ENV === "production"
		? window.location.href.includes("planner.simple.events")
			? `https://admin-api.simple.events/`
			: `https://beta-api.simple.events/`
		: `http://${window.location.hostname}:5015/`;

const getItemStyle = (_, draggableStyle) => ({
	userSelect: "none",
	...draggableStyle,
});

const defaultAppScreens = [
	{
		id: 'homePage',
		name: 'Home',
		enabled: true,
		icon: 'las la-home',
		description: 'Image, Welcome Message, and Event Details',
	},
	{
		id: 'agendaPage',
		name: 'Agenda',
		enabled: true,
		icon: 'las la-calendar-alt',
		description: 'Event Schedule'
	},
	{
		id: 'mapsPage',
		name: 'Maps',
		enabled: true,
		icon: 'las la-map-marker'
	},
	{
		id: 'speakersPage',
		name: 'Speakers',
		enabled: true,
		icon: 'las la-users',
	},
	{
		id: 'attendeesPage',
		name: 'Attendees',
		enabled: true,
		icon: 'las la-user-friends'
	}, {
		id: 'attendeeFeedPage',
		name: "Feed",
		enabled: true,
		icon: 'las la-images'
	},
	{
		id: 'scannerPage',
		name: 'Scanner',
		enabled: true,
		icon: 'las la-camera'
	},
	{
		id: 'eventPassPage',
		name: 'Event Pass',
		enabled: false,
		icon: 'las la-qrcode'
	},
	{
		id: 'leaderboardPage',
		name: 'Leaderboard',
		enabled: true,
		icon: 'las la-trophy'
	}
]

class ApplicationSetup extends Component {
	constructor(props) {
		super(props);
		let filterFields = {
			email: 'Email',
			firstName: 'First Name',
			lastName: 'Last Name',
			attendance: 'Attendance',
			title: 'Title',
			phoneNumber: 'Phone Number',
			company: 'Company',
			dietaryPreference: 'Dietary Preference',
			foodAllergies: 'Food Allergies',
			emergencyContactName: 'Emergency Contact Name',
			emergencyContactPhoneNumber: 'Emergency Contact Phone Number',
			address: 'Address',
			address2: 'Address 2',
			city: 'City',
			state: 'State',
			zip: 'Zip',
			country: 'Country',
			status: 'Status',
			denialReason: 'Denial Reason',
			denialComment: 'Denial Comment',
			role: 'Role'
		};
		const attendeeCustomFields = props.event.customFields.attendees || [];

		attendeeCustomFields.forEach((category) => {
			const fields = category.fields;
			fields.forEach((f) => {
				filterFields[category._id + '*' + f._id] = f.fieldName;
			});
		});




		const speakerMap = {};
		props.sessions.forEach((session) => {
			session.speakers &&
				session.speakers.forEach((speaker) => {
					const speakerId = speaker._id ? speaker._id : speaker;
					const speakerData = props.attendees.find((a) => a._id === speakerId);
					if (speakerData) {
						speakerMap[speakerId] = {
							firstName: speakerData.firstName,
							lastName: speakerData.lastName,
							email: speakerData.email,
							title: speakerData.title,
							profilePicture: speakerData.profilePicture,
						};
					}
				});
		});
		const appConfigurationScreens = props.event.appConfiguration.screens;
		for(let screen of defaultAppScreens) {
			const screenFound = appConfigurationScreens.find(s => s.id == screen.id);
			if(!screenFound) {
				appConfigurationScreens.push(screen)
			}
		}
		this.state = {
			selectedSection: 0,
			loading: true,
			editing: false,
			requiredFields: {},
			renderURL: `Organizations/${this.props.orgId}/events/${this.props.eventId}/pages/render/app/`,
			appConfig: JSON.parse(JSON.stringify({...props.event.appConfiguration, screens: appConfigurationScreens})),
			addPageFromSiteModalOpen: false,
			editEmbeddedPageModalOpen: false,
			pages: [],
			selectedPage: null,
			selectedGroup: { label: 'No restrictions', value: null },
			selectedIcon: "",
			iconError: false,
			pageError: false,
			expandedPages: {
				homePage: true,
				agendaPage: false,
				speakersPage: false,
				mapsPage: false,
				attendeesPage: false,
				attendeeFeedPage: false,
				scannerPage: false,
				leaderboardPage: false,
				profilePage: false,
				loginPage: false,
			},
			focusedPage: "homePage",
			uploadingHomeBanner: false,
			uploadingLoginBackgroundImage: false,
			uploadingAppIcon: "",
			uploadingSplashImage: "",
			addSpeakersModalOpen: false,
			selectedSpeaker: null,
			addSponsorsModalOpen: false,
			selectedSponsor: null,
			editCount: 0,
			speakerMap,
			guideCopied: false,
			linkCopied: false,
			runPageTutorial: false,
			filterFields: filterFields
		};
	}

	async componentWillMount() {
		const { orgId, eventId } = this.props;
		await API()
			.get(`Organizations/${orgId}/events/${eventId}/pages`)
			.then((res) => {
				if (res.data) {
					this.setState({
						pages: res.data.pages.map((p) => {
							p.label = p.title;
							p.value = `page-${p._id}`;
							p.link = `/${orgId}/events/${eventId}/pages/${p._id}`;
							return p;
						}),
					});
				}
			});
	}

	saveInfo = () => {
		const { orgId, eventId } = this.props;
		const {
			brandColor,
			buttonTextColor,
			name,
			shortName,
			description,
			backgroundColor,
			themeColor,
			installationPrompt,
		} = this.props.event.appConfiguration;
		const configurationComplete =
			name !== "" &&
			shortName !== "" &&
			description !== "" &&
			backgroundColor !== "" &&
			themeColor !== "" &&
			installationPrompt !== "";
		const customizationComplete =
			brandColor !== "" && buttonTextColor !== "";

		if (!configurationComplete || !customizationComplete) {
			this.setState({
				appConfig: {
					...this.state.appConfig,
					enabled: false,
				}
			})
		}
		API()
			.patch(`Organizations/${orgId}/events/${eventId}/appConfiguration`, {
				appConfiguration: {
					...this.state.appConfig,
					enabled: this.state.appConfig.enabled && configurationComplete && customizationComplete,
				},
			})
			.then((res) => {
				if (res.data) {
					this.props.updateSetup(this.state.appConfig);
					this.setState({
						editing: false,
						invalid: false,
					});
				}
			})
			.catch((e) => {
				this.setState({
					invalid: true,
					submitting: false,
				});
			});
	};

	handleCopyGuide = () => {
		const guideContent = `
		For iOS Devices:
		1. Open the event link in Safari.
		2. Tap the Share button (square with an arrow).
		3. Scroll and select "Add to Home Screen".
		4. Name the app (if desired).
		5. Tap "Add".
		6. The app icon will now appear on your home screen.

		Troubleshooting:
		• Ensure you're using Safari.
		• Check that your iOS is up to date.
		• Close and reopen Safari if needed.
		• Verify you have sufficient device storage.

		For Android Devices:
		1. Open the event link in your mobile browser.
		2. Tap the "Add to Home Screen" button in the browser menu.
		3. Tap "Add" or "Install" in the pop-up window.
		4. The app icon will now appear on your home screen.

		Troubleshooting:
		• If no prompt appears, look for the browser's menu (three dots).
		• Select "Add to Home Screen" from the menu.
		• Ensure you have enough storage space.
		• Restart your browser if installation fails.
        `;

		navigator.clipboard
			.writeText(guideContent)
			.then(() => {
				this.setState({ guideCopied: true });
				setTimeout(() => {
					this.setState({ guideCopied: false });
				}, 2000);
			})
			.catch((err) => console.error("Failed to copy guide:", err));
	};

	handleCopyEventLink = () => {
		const link = this.props.org.hostname ? `https://${this.props.org.hostname}/${this.props.event.nameSlug}/App` : `https://${this.props.org.identifier}.simple.events/${this.props.event.nameSlug}/App`;
		navigator.clipboard
			.writeText(link)
			.then(() => {
				this.setState({ linkCopied: true });
				setTimeout(() => {
					this.setState({ linkCopied: false });
				}, 2000);
			})
			.catch((err) => console.error("Failed to copy link:", err));
	};

	cancelEdit = () => {
		this.setState({
			editing: false,
			appConfig: JSON.parse(JSON.stringify(this.props.event.appConfiguration)),
			editCount: 0,
		});
	};

	renderSection = () => {
		const { selectedSection, appConfig, expandedPages, requiredFields, filterFields } =
			this.state;
		const { readOnly, attendees, event } = this.props;
		let selectedScreen = this.state.appConfig.screens[0];
		const enabledScreens = {};
		appConfig.screens.forEach((screen) => {
			if (screen.id === this.state.appConfig.defaultScreen) {
				selectedScreen = screen;
			}
			if (screen.enabled) {
				enabledScreens[screen.id] = screen;
			}
		});
		let groups = event.groups;
		let mappedFields = [];
		Object.keys(filterFields).forEach((key) => {
			mappedFields.push({
				label: filterFields[key],
				value: key,
			});
		});
		switch (selectedSection) {
			case 0:
				return (
					<div className="flex h-100 mobileConfig">
						<div className="sectionBlock">
							<h2 className="blockHeader">Top Navigation</h2>
							<div className="blockBody">
								<ToggleField
									label="Enable Notifications"
									icons={false}
									checked={this.state.appConfig.enableNotifications}
									onChange={(val) => {
										this.setState({
											appConfig: {
												...this.state.appConfig,
												enableNotifications: val.target.checked,
											},
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
								/>
								<ToggleField
									label="Enable Event Logo"
									icons={false}
									checked={this.state.appConfig.enableEventLogo}
									onChange={(val) => {
										this.setState({
											appConfig: {
												...this.state.appConfig,
												enableEventLogo: val.target.checked,
											},
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
								/>
							</div>
							<h2 className="blockHeader">Bottom Navigation</h2>
							<div className="blockBody">
								<SelectField
									label="Default Screen"
									options={Object.values(enabledScreens).map((screen) => {
										return { label: screen.name, value: screen.id };
									})}
									onChange={(val) => {
										this.setState({
											appConfig: {
												...this.state.appConfig,
												defaultScreen: val.value,
											},
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
									value={{
										label: selectedScreen.name,
										value: selectedScreen.id,
									}}
								/>
								<DragDropContext
									className="dragContainer"
									onDragEnd={(res) => {
										if (!res.destination) return;
										const screens = this.state.appConfig.screens;
										const [reorderedItem] = screens.splice(res.source.index, 1);
										screens.splice(res.destination.index, 0, reorderedItem);
										this.setState({
											appConfig: { ...this.state.appConfig, screens },
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
								>
									<Droppable droppableId="droppable">
										{(provided, snapshot) => (
											<div ref={provided.innerRef}>
												{this.state.appConfig.screens.map((screen, index) => {
													return (
														<Draggable
															draggableId={`screen-${screen.id}`}
															index={index}
															key={screen.id}
														>
															{(provided, snapshot) => (
																<div
																	{...provided.draggableProps}
																	{...provided.dragHandleProps}
																	style={getItemStyle(
																		snapshot.isDragging,
																		provided.draggableProps.style
																	)}
																	ref={provided.innerRef}
																	className="dragItem"
																	key={index}
																>
																	<i className="las la-braille" />
																	{screen.custom && (
																		<button
																			className="neu"
																			onClick={() => {
																				const selectedPage =
																					this.state.pages.find(
																						(p) => p._id === screen.pageId
																					);
																				let screenIcon = screen.icon.split("/");
																				screenIcon =
																					screenIcon[screenIcon.length - 2];
																				let selectedGroup = screen.assignedGroups ? groups.find((group) => group._id === screen.assignedGroups[0]) : null;
																				this.setState({
																					selectedPage,
																					selectedGroup: selectedGroup ? { label: selectedGroup.name, value: selectedGroup._id } : { label: 'No restrictions', value: null },
																					selectedIcon: screenIcon,
																					editEmbeddedPageModalOpen: true,
																				});
																			}}
																		>
																			<i className="las la-pen"></i>
																		</button>
																	)}
																	<ToggleField
																		label={screen.name}
																		icons={false}
																		checked={screen.enabled}
																		onChange={(val) => {
																			const screens =
																				this.state.appConfig.screens;
																			screens[index].enabled =
																				val.target.checked;
																			this.setState({
																				appConfig: {
																					...this.state.appConfig,
																					screens,
																				},
																				editCount: this.state.editCount + 1,
																				editing: true,
																			});
																		}}
																	/>
																</div>
															)}
														</Draggable>
													);
												})}
											</div>
										)}
									</Droppable>
								</DragDropContext>

								<button
									className="neu ml-a mt-20"
									onClick={() => {
										this.setState({ addPageFromSiteModalOpen: true, selectedPage: null, selectedGroup: { label: 'No restrictions', value: null }, selectedIcon: "" });
									}}
								>
									Add Page From Website
								</button>
							</div>
						</div>
						<div className="p-20">
							<PagePreviewFrame
								setPreviewDimensions={({ width, height }) => {
									this.setState({
										frameWidth: width,
										frameHeight: height,
									});
								}}
								ref={(el) => (this.preview = el)}
								editing={this.state.editCount}
								saving={this.state.saving}
								ENV={ENV}
								renderURL={this.state.renderURL}
								focusedComponent={""}
								pageProperties={{}}
								simulatedUser={{ value: attendees[0].id }}
								simulatedSession={{}}
								postData={{
									appConfiguration: this.state.appConfig,
								}}
							/>
						</div>
						<FieldModal
							size="medium"
							isOpen={this.state.addPageFromSiteModalOpen}
							modalTitle={"Add Page From Website"}
							bodyHeaderText={""}
							bodyDescription={""}
							bodyContent={() => {
								return (
									<div>
										<SelectField
											label="Page"
											options={this.state.pages}
											errorTrigger={this.state.pageError}
											errorMessage="Please select a page"
											onChange={(val) => {
												this.setState({ selectedPage: val, pageError: false });
											}}
											value={this.state.selectedPage}
											required={true}
										/>
										<SelectField
											label="Group"
											options={[{ label: 'No restrictions', value: null }, ...groups.map((group) => {
												return {
													label: group.name,
													value: group._id,
												};
											}
											)]}
											onChange={(val) => {
												this.setState({ selectedGroup: val });
											}}
											value={this.state.selectedGroup}
										/>
										<IconChooserBox
											label="Navigation Icon"
											required={true}
											value={this.state.selectedIcon}
											errorTrigger={this.state.iconError}
											errorMessage="Please select an icon"
											onClick={(val) => {
												this.setState({
													selectedIcon: val,
													iconError: false // Clear error when icon is selected
												});
											}}
										/>
									</div>
								);
							}}
							toggle={() => {
								this.setState({ addPageFromSiteModalOpen: false });
							}}
							actionButtonLabel={"Add Page"}
							actionButton={() => {

								if (!this.state.selectedIcon || !this.state.selectedPage) {
									this.setState({ iconError: true, pageError: true });
									return;
								}
								const screens = this.state.appConfig.screens;
								let pageSelection = {
									id: this.state.selectedPage.value,
									name: this.state.selectedPage.label,
									icon: `/API/icons/svg/${this.state.selectedIcon}/black`,
									slug: this.state.selectedPage.slug,
									enabled: true,
									custom: true,
									pageId: this.state.selectedPage._id,
								};
								if (this.state.selectedGroup.value) {
									pageSelection.assignedGroups = [this.state.selectedGroup.value];
								}

								screens.push(pageSelection);
								this.setState({
									appConfig: { ...this.state.appConfig, screens },
									addPageFromSiteModalOpen: false,
									editCount: this.state.editCount + 1,
									editing: true,
									selectedPage: null,
									selectedIcon: "",
								});
							}}
						/>

						<FieldModal
							size="medium"
							isOpen={this.state.editEmbeddedPageModalOpen}
							modalTitle={"Edit Page From Website"}
							bodyHeaderText={""}
							bodyDescription={""}
							bodyContent={() => {
								return (
									<div>
										<SelectField
											label="Page"
											options={this.state.pages}
											onChange={(val) => {
												this.setState({ selectedPage: val });
											}}
											value={this.state.selectedPage}
										/>
										<SelectField
											label="Group"
											options={[{ label: 'No restrictions', value: null }, ...groups.map((group) => {
												return {
													label: group.name,
													value: group._id,
												};
											}
											)]}
											onChange={(val) => {
												this.setState({ selectedGroup: val });
											}}
											value={this.state.selectedGroup}
										/>
										<IconChooserBox
											label="Navigation Icon"
											required={true}
											value={this.state.selectedIcon}
											onClick={(val) => {
												this.setState({ selectedIcon: val });
											}}
										/>
									</div>
								);
							}}
							toggle={() => {
								this.setState({ editEmbeddedPageModalOpen: false });
							}}
							actionButtonLabel={"Update Navigation"}
							actionButton={() => {
								const screens = this.state.appConfig.screens;
								const screen = screens.find(
									(s) => s.id === this.state.selectedPage.value
								);
								screen.icon = `/API/icons/svg/${this.state.selectedIcon}/black`;
								screen.name = this.state.selectedPage.label;
								screen.pageId = this.state.selectedPage._id;
								if (this.state.selectedGroup) {
									screen.assignedGroups = [this.state.selectedGroup.value];
								} else {
									screen.assignedGroups = [];
								}

								this.setState({
									appConfig: { ...this.state.appConfig, screens },
									editEmbeddedPageModalOpen: false,
									editCount: this.state.editCount + 1,
									editing: true,
									selectedPage: null,
									selectedIcon: "",
								});
							}}
							cancelButtonLabel={"Remove Page"}
							cancelOnClick={() => {
								const screens = this.state.appConfig.screens;
								const screenIndex = screens.findIndex(
									(s) => s.id === this.state.selectedPage.value
								);
								screens.splice(screenIndex, 1);
								this.setState({
									appConfig: { ...this.state.appConfig, screens },
									editEmbeddedPageModalOpen: false,
									editCount: this.state.editCount + 1,
									editing: true,
									selectedPage: null,
									selectedIcon: "",
								});
							}}
						/>
					</div>
				);
			case 1:
				return (
					<div className="flex h-100 mobileConfig">
						<div className="sectionBlock">
							{enabledScreens["homePage"] && (
								<>
									<div
										className="flex aic jcsb c-pointer"
										onClick={() => {
											const exPages = this.state.expandedPages;
											Object.keys(exPages).forEach((key) => {
												exPages[key] = false;
												if (key === "homePage") {
													exPages[key] = true;
												}
											});
											this.setState({
												expandedPages: exPages,
												focusedPage: "homePage",
												editCount: this.state.editCount + 1,
											});
										}}
									>
										<h2 className="blockHeader">Home Screen</h2>
										{!expandedPages["homePage"] && (
											<i className="las la-angle-down"></i>
										)}
										{expandedPages["homePage"] && (
											<i className="las la-angle-up"></i>
										)}
									</div>

									{expandedPages["homePage"] && (
										<div className="blockBody">
											<div className="editorFileInput">
												<FileChooserPreview
													label="Banner Image"
													value={appConfig.homeBannerImage}
													clearFile={() => {
														this.setState({
															appConfig: {
																...this.state.appConfig,
																homeBannerImage: "",
															},
															editCount: this.state.editCount + 1,
															editing: true,
														});
													}}
													onClick={(e) => {
														this.setState({ uploadingHomeBanner: true });
													}}
												/>
												<FilesUploaderModal
													title="Image"
													links={{
														getAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
														addAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
													}}
													isOpen={this.state.uploadingHomeBanner}
													toggle={() => {
														this.setState({
															uploadingHomeBanner: false,
														});
													}}
													orgId={this.props.orgId}
													addFiles={(fileURL) => {
														this.setState({
															appConfig: {
																...this.state.appConfig,
																homeBannerImage: fileURL,
															},
															editCount: this.state.editCount + 1,
															editing: true,
															uploadingHomeBanner: false,
														});
													}}
												/>
											</div>
											<ToggleField
												label="Enable Welcome Message Section"
												icons={false}
												checked={appConfig.enableHomeMessage}
												onChange={(val) => {
													this.setState({
														appConfig: {
															...this.state.appConfig,
															enableHomeMessage: val.target.checked,
														},
														editCount: this.state.editCount + 1,
														editing: true,
													});
												}}
											/>
											{appConfig.enableHomeMessage && (
												<>
													<InputField
														label="Message Title"
														value={appConfig.homeMessageTitle}
														onChange={(val) => {
															this.setState({
																appConfig: {
																	...this.state.appConfig,
																	homeMessageTitle: val.target.value,
																},
																editCount: this.state.editCount + 1,
																editing: true,
															});
														}}
													/>
													<RichTextEditor
														id="homeMessageBody"
														label="Message Body"
														value={appConfig.homeMessageBody}
														onChange={(val) => {
															this.setState({
																appConfig: {
																	...this.state.appConfig,
																	homeMessageBody: val,
																},
																editCount: this.state.editCount + 1,
																editing: true,
															});
														}}
													/>
												</>
											)}
											<ToggleField
												label="Enable Agenda Preview Section"
												icons={false}
												checked={appConfig.enableHomeAgendaPreview}
												onChange={(val) => {
													this.setState({
														appConfig: {
															...this.state.appConfig,
															enableHomeAgendaPreview: val.target.checked,
														},
														editCount: this.state.editCount + 1,
														editing: true,
													});
												}}
											/>
											<ToggleField
												label="Enable Featured Speakers Section"
												icons={false}
												checked={appConfig.enableHomeFeaturedSpeakers}
												onChange={(val) => {
													this.setState({
														appConfig: {
															...this.state.appConfig,
															enableHomeFeaturedSpeakers: val.target.checked,
														},
														editCount: this.state.editCount + 1,
														editing: true,
													});
												}}
											/>
											{appConfig.enableHomeFeaturedSpeakers && (
												<>
													<DragDropContext
														className="dragContainer"
														onDragEnd={(res) => {
															if (!res.destination) return;
															const featuredSpeakers =
																this.state.appConfig.featuredSpeakers;
															const [reorderedItem] = featuredSpeakers.splice(
																res.source.index,
																1
															);
															featuredSpeakers.splice(
																res.destination.index,
																0,
																reorderedItem
															);
															this.setState({
																appConfig: {
																	...this.state.appConfig,
																	featuredSpeakers,
																},
																editCount: this.state.editCount + 1,
																editing: true,
															});
														}}
													>
														<Droppable droppableId="droppable">
															{(provided, snapshot) => (
																<div ref={provided.innerRef}>
																	{appConfig.featuredSpeakers &&
																		appConfig.featuredSpeakers.map(
																			(speakerId, index) => {
																				const speaker =
																					this.state.speakerMap[speakerId];
																				if (!speaker) return null;
																				return (
																					<Draggable
																						draggableId={`speaker-${speakerId}`}
																						index={index}
																						key={speakerId}
																					>
																						{(provided, snapshot) => (
																							<div
																								{...provided.draggableProps}
																								{...provided.dragHandleProps}
																								style={getItemStyle(
																									snapshot.isDragging,
																									provided.draggableProps.style
																								)}
																								ref={provided.innerRef}
																								className="dragItem"
																								key={index}
																							>
																								<i className="las la-braille" />
																								<div className="flex aic">
																									<div className="speakerContainer" style={{ display: 'flex', alignItems: 'center' }}>
																										{speaker.profilePicture ? (
																											<img
																												src={speaker.profilePicture}
																												style={{
																													width: 30,
																													height: 30,
																													borderRadius: 5,
																												}}
																												alt="speaker"
																											/>
																										) : (
																											<img
																												src="https://assets-simpleevents.s3.us-east-1.amazonaws.com/app/Profile+Image.png"
																												style={{
																													width: 30,
																													height: 30,
																													borderRadius: 5,
																												}}
																												alt="Speaker Image" />
																										)}
																									</div>
																									<div className="ml-10">
																										{speaker.firstName}{" "}
																										{speaker.lastName} (
																										{speaker.email})
																									</div>
																								</div>
																								<button
																									className="neu ml-a"
																									onClick={() => {
																										const featuredSpeakers =
																											this.state.appConfig
																												.featuredSpeakers;
																										featuredSpeakers.splice(
																											index,
																											1
																										);
																										this.setState({
																											appConfig: {
																												...this.state.appConfig,
																												featuredSpeakers,
																											},
																											editCount:
																												this.state.editCount +
																												1,
																											editing: true,
																										});
																									}}
																								>
																									<i className="las la-trash"></i>
																								</button>
																							</div>
																						)}
																					</Draggable>
																				);
																			}
																		)}
																</div>
															)}
														</Droppable>
													</DragDropContext>

													<button
														className="neu ml-a mb-20"
														onClick={() => {
															this.setState({ addSpeakersModalOpen: true });
														}}
													>
														Add Featured Speaker
													</button>
													<FieldModal
														size="medium"
														isOpen={this.state.addSpeakersModalOpen}
														modalTitle={"Add Featured Speaker"}
														bodyHeaderText={""}
														bodyDescription={""}
														bodyContent={() => {
															return (
																<div>
																	<SelectField
																		label="Speaker"
																		options={Object.keys(
																			this.state.speakerMap
																		)
																			.filter((speakerId) =>
																				!this.state.appConfig.featuredSpeakers.includes(speakerId))
																			.map((speakerId) => {
																				const speaker =
																					this.state.speakerMap[speakerId];
																				return {
																					label: `${speaker.firstName} ${speaker.lastName} (${speaker.email})`,
																					value: speakerId,
																				};
																			})}
																		onChange={(val) => {
																			this.setState({ selectedSpeaker: val });
																		}}
																		value={this.state.selectedSpeaker}
																	/>
																</div>
															);
														}}
														toggle={() => {
															this.setState({
																addSpeakersModalOpen: false,
																selectedSpeaker: null,
															});
														}}
														actionButtonLabel={"Add Speaker"}
														actionButton={() => {
															const featuredSpeakers =
																this.state.appConfig.featuredSpeakers;
															featuredSpeakers.push(
																this.state.selectedSpeaker.value
															);
															this.setState({
																appConfig: {
																	...this.state.appConfig,
																	featuredSpeakers,
																},
																addSpeakersModalOpen: false,
																editCount: this.state.editCount + 1,
																editing: true,
																selectedSpeaker: null,
															});
														}}
													/>
												</>
											)}
											<ToggleField
												label="Enable Sponsors Section"
												icons={false}
												checked={appConfig.enableHomeSponsors}
												onChange={(val) => {
													this.setState({
														appConfig: {
															...this.state.appConfig,
															enableHomeSponsors: val.target.checked,
														},
														editCount: this.state.editCount + 1,
														editing: true,
													});
												}}
											/>
											{appConfig.enableHomeSponsors && (
												<>
													{appConfig.sponsors &&
														appConfig.sponsors.map((sponsor, index) => {
															return (
																<div className="flex aic jcsb" key={index}>
																	<div className="flex aic">
																		<img
																			src={sponsor.image}
																			style={{ width: 50, height: 50 }}
																			alt="sponsor"
																		/>
																		<div className="ml-10">{sponsor.name}</div>
																	</div>
																	<button className="neu ml-a">
																		<i className="las la-trash"></i>
																	</button>
																</div>
															);
														})}

													<button className="neu ml-a">Add Sponsor</button>
												</>
											)}
										</div>
									)}
								</>
							)}
							{enabledScreens["speakersPage"] && (
								<>
									<div
										className="flex aic jcsb c-pointer"
										onClick={() => {
											const exPages = this.state.expandedPages;
											Object.keys(exPages).forEach((key) => {
												exPages[key] = false;
												if (key === "speakersPage") {
													exPages[key] = true;
												}
											});
											this.setState({
												expandedPages: exPages,
												focusedPage: "speakersPage",
												editCount: this.state.editCount + 1,
											});
										}}
									>
										<h2 className="blockHeader">Speakers Screen</h2>
										{!expandedPages["speakersPage"] && (
											<i className="las la-angle-down"></i>
										)}
										{expandedPages["speakersPage"] && (
											<i className="las la-angle-up"></i>
										)}
									</div>

									{expandedPages["speakersPage"] && (
										<div className="blockBody">
											<ToggleField
												label="Enable Speaker Details Page"
												icons={false}
												checked={appConfig.enableSpeakerDetails}
												onChange={(val) => {
													this.setState({
														appConfig: {
															...this.state.appConfig,
															enableSpeakerDetails: val.target.checked,
														},
														editCount: this.state.editCount + 1,
														editing: true,
													});
												}}
											/>
										</div>
									)}
								</>
							)}
							{enabledScreens["attendeesPage"] && (
								<>
									<div
										className="flex aic jcsb c-pointer"
										onClick={() => {
											const exPages = this.state.expandedPages;
											Object.keys(exPages).forEach((key) => {
												exPages[key] = false;
												if (key === "attendeesPage") {
													exPages[key] = true;
												}
											});
											this.setState({
												expandedPages: exPages,
												focusedPage: "attendeesPage",
												editCount: this.state.editCount + 1,
											});
										}}
									>
										<h2 className="blockHeader">Attendees Screen</h2>
										{!expandedPages["attendeesPage"] && (
											<i className="las la-angle-down"></i>
										)}
										{expandedPages["attendeesPage"] && (
											<i className="las la-angle-up"></i>
										)}
									</div>

									{expandedPages["attendeesPage"] && (
										<div className="blockBody">
											<ToggleField
												label="Enable Attendee Filters"
												icons={false}
												checked={appConfig.enableAttendeeFilters}
												onChange={(val) => {
													this.setState({
														appConfig: {
															...this.state.appConfig,
															enableAttendeeFilters: val.target.checked,
														},
														editCount: this.state.editCount + 1,
														editing: true,
													});
												}}
											/>

											{appConfig.enableAttendeeFilters && (
												<div className="flex column  ">
													{appConfig.attendeeFilters &&
														appConfig.attendeeFilters.map((filter, index) => {
															return (
																<div
																	className="flex aic jcsb formFieldContainer "
																	key={index}
																>
																	<div className="ml-10">{filterFields[filter]}</div>
																	<button
																		className="neu ml-a"
																		onClick={() => {
																			const attendeeFilters =
																				this.state.appConfig.attendeeFilters;
																			attendeeFilters.splice(index, 1);
																			this.setState({
																				appConfig: {
																					...this.state.appConfig,
																					attendeeFilters,
																				},
																				editCount:
																					this.state.editCount + 1,
																				editing: true,
																			});
																		}}
																	>
																		<i className="las la-trash"></i>
																	</button>
																</div>
															);
														})}
													<button
														className="neu ml-a mb-20"
														onClick={() => {
															this.setState({ addAttendeeFiltersModalOpen: true });
														}}
													>
														Add Attendee Filter
													</button>
												</div>
											)}






											<FieldModal
												size="medium"
												isOpen={this.state.addAttendeeFiltersModalOpen}
												modalTitle={"Add Attendee Filter"}
												bodyHeaderText={""}
												bodyDescription={""}
												bodyContent={() => {
													return (
														<div>
															<SelectField
																label="Attendee Field"
																options={mappedFields.filter(field =>
																	!appConfig.attendeeFilters?.includes(field.value)
																)}
																onChange={(val) => {
																	this.setState({ selectedAttendeeFilter: val });
																}}
																value={this.state.selectedAttendeeFilter}
															/>
														</div>
													);
												}}
												toggle={() => {
													this.setState({
														addAttendeeFiltersModalOpen: false,
														selectedAttendeeFilter: null,
													});
												}}
												actionButtonLabel={"Add Filter"}
												actionButton={() => {
													const attendeeFilters =
														this.state.appConfig.attendeeFilters;
													if (!attendeeFilters.includes(this.state.selectedAttendeeFilter.value)) {
														attendeeFilters.push(this.state.selectedAttendeeFilter.value);
													}
													this.setState({
														appConfig: {
															...this.state.appConfig,
															attendeeFilters,
														},
														addAttendeeFiltersModalOpen: false,
														editCount: this.state.editCount + 1,
														editing: true,
														selectedAttendeeFilter: null,
													});
												}}
											/>


											<ToggleField
												label="Enable Attendee Details Page"
												icons={false}
												checked={appConfig.enableAttendeeDetails}
												onChange={(val) => {
													this.setState({
														appConfig: {
															...this.state.appConfig,
															enableAttendeeDetails: val.target.checked,
														},
														editCount: this.state.editCount + 1,
														editing: true,
													});
												}}
											/>

											{appConfig.enableAttendeeDetails && (
												<>
													<ToggleField
														label="Display Email Address"
														icons={false}
														checked={appConfig.displayAttendeeEmail}
														onChange={(val) => {
															this.setState({
																appConfig: {
																	...this.state.appConfig,
																	displayAttendeeEmail: val.target.checked,
																},
																editCount: this.state.editCount + 1,
																editing: true,
															});
														}}
													/>
													<ToggleField
														label="Display Phone Number"
														icons={false}
														checked={appConfig.displayAttendeePhone}
														onChange={(val) => {
															this.setState({
																appConfig: {
																	...this.state.appConfig,
																	displayAttendeePhone: val.target.checked,
																},
																editCount: this.state.editCount + 1,
																editing: true,
															});
														}}
													/>
													<ToggleField
														label="Display Biography"
														icons={false}
														checked={appConfig.displayAttendeeBio}
														onChange={(val) => {
															this.setState({
																appConfig: {
																	...this.state.appConfig,
																	displayAttendeeBio: val.target.checked,
																},
																editCount: this.state.editCount + 1,
																editing: true,
															});
														}}
													/>
													<ToggleField
														label="Display Social Media"
														icons={false}
														checked={appConfig.displayAttendeeSocial}
														onChange={(val) => {
															this.setState({
																appConfig: {
																	...this.state.appConfig,
																	displayAttendeeSocial: val.target.checked,
																},
																editCount: this.state.editCount + 1,
																editing: true,
															});
														}}
													/>
												</>
											)}
										</div>
									)}
								</>
							)}

							{enabledScreens["attendeeFeedPage"] && (
								<>
									<div
										className="flex aic jcsb c-pointer"
										onClick={() => {
											const exPages = this.state.expandedPages;
											Object.keys(exPages).forEach((key) => {
												exPages[key] = false;
												if (key === "attendeeFeedPage") {
													exPages[key] = true;
												}
											});
											this.setState({
												expandedPages: exPages,
												focusedPage: "attendeeFeedPage",
												editCount: this.state.editCount + 1,
											});
										}}
									>
										<h2 className="blockHeader">Attendee Feed Screen</h2>
										{!expandedPages["attendeeFeedPage"] && (
											<i className="las la-angle-down"></i>
										)}
										{expandedPages["attendeeFeedPage"] && (
											<i className="las la-angle-up"></i>
										)}
									</div>

									{expandedPages["attendeeFeedPage"] && (
										<div className="blockBody">
											<TextAreaField label="Feed Description"
												value={appConfig.feedDescription}
												onChange={(val) => {
													this.setState({
														appConfig: {
															...this.state.appConfig,
															feedDescription: val.target.value,
														},
														editCount: this.state.editCount + 1,
														editing: true,
													});
												}}
											/>
											<ToggleField
												label="Enable Feed Post Comments"
												icons={false}
												checked={appConfig.enableFeedComments}
												onChange={(val) => {
													this.setState({
														appConfig: {
															...this.state.appConfig,
															enableFeedComments: val.target.checked,
														},
														editCount: this.state.editCount + 1,
														editing: true,
													});
												}}
											/>
										</div>
									)}
								</>
							)}
							{/* {enabledScreens["attendeeMadeSessionsPage"] && (
								<>
									<div
										className="flex aic jcsb c-pointer"
										onClick={() => {
											const exPages = this.state.expandedPages;
											let exist = false;
											Object.keys(exPages).forEach((key) => {
												exPages[key] = false;
												if (key === "attendeeMadeSessionsPage") {
													exPages[key] = true;
													exist = true;
												}
											});
											if (!exist) {
												exPages["attendeeMadeSessionsPage"] = true;
											}

											this.setState({
												expandedPages: exPages,
												focusedPage: "attendeeMadeSessionsPage",
												editCount: this.state.editCount + 1,
											});
										}}
									>
										<h2 className="blockHeader">On Demand Meetings Screen</h2>
										{!expandedPages["attendeeMadeSessionsPage"] && (
											<i className="las la-angle-down"></i>
										)}
										{expandedPages["attendeeMadeSessionsPage"] && (
											<i className="las la-angle-up"></i>
										)}
									</div>

									{expandedPages["attendeeMadeSessionsPage"] && (
										<div className="blockBody">
											<ToggleField
												label="Allow Attendee to Create Meetings"
												icons={false}
												checked={appConfig.allowAttendeeMadeSessions}
												onChange={(val) => {
													this.setState({
														appConfig: {
															...this.state.appConfig,
															allowAttendeeMadeSessions: val.target.checked,
														},
														editCount: this.state.editCount + 1,
														editing: true,
													});
												}}
											/>
										</div>
									)}
								</>
							)} */}
							<div
								className="flex aic jcsb c-pointer"
								onClick={() => {
									const exPages = this.state.expandedPages;
									Object.keys(exPages).forEach((key) => {
										exPages[key] = false;
										if (key === "profilePage") {
											exPages[key] = true;
										}
									});
									this.setState({
										expandedPages: exPages,
										focusedPage: "homePage",
										editCount: this.state.editCount + 1,
									});
								}}
							>
								<h2 className="blockHeader">Profile Screen</h2>
								{!expandedPages["profilePage"] && (
									<i className="las la-angle-down"></i>
								)}
								{expandedPages["profilePage"] && (
									<i className="las la-angle-up"></i>
								)}
							</div>

							{expandedPages["profilePage"] && (
								<div className="blockBody">
									<ToggleField
										label="Allow Profile Editing"
										icons={false}
										checked={appConfig.allowProfileEditing}
										onChange={(val) => {
											this.setState({
												appConfig: {
													...this.state.appConfig,
													allowProfileEditing: val.target.checked,
												},
												editCount: this.state.editCount + 1,
												editing: true,
											});
										}}
									/>

									<ToggleField
										label="Display Biography"
										icons={false}
										checked={appConfig.displayProfileBio}
										onChange={(val) => {
											this.setState({
												appConfig: {
													...this.state.appConfig,
													displayProfileBio: val.target.checked,
												},
												editCount: this.state.editCount + 1,
												editing: true,
											});
										}}
									/>

									<ToggleField
										label="Display Social Media"
										icons={false}
										checked={appConfig.displayProfileSocials}
										onChange={(val) => {
											this.setState({
												appConfig: {
													...this.state.appConfig,
													displayProfileSocials: val.target.checked,
												},
												editCount: this.state.editCount + 1,
												editing: true,
											});
										}}
									/>
								</div>
							)}
							<div
								className="flex aic jcsb c-pointer"
								onClick={() => {
									const exPages = this.state.expandedPages;
									Object.keys(exPages).forEach((key) => {
										exPages[key] = false;
										if (key === "loginPage") {
											exPages[key] = true;
										}
									});
									this.setState({
										expandedPages: exPages,
										focusedPage: "loginPage",
										editCount: this.state.editCount + 1,
									});
								}}
							>
								<h2 className="blockHeader">Login Screen</h2>
								{!expandedPages["loginPage"] && (
									<i className="las la-angle-down"></i>
								)}
								{expandedPages["loginPage"] && (
									<i className="las la-angle-up"></i>
								)}
							</div>

							{expandedPages["loginPage"] && (
								<div className="blockBody">
									<InputField
										label="Login Description"
										value={appConfig.loginDescription}
										disabled={readOnly}
										onChange={(e) => {
											this.setState({
												appConfig: { ...appConfig, loginDescription: e.target.value },
												editing: true,
											});
										}}
									/>

									<FileChooserPreview
										label="Background Image"
										value={appConfig.loginBackgroundImage}
										clearFile={() => {
											this.setState({
												appConfig: {
													...this.state.appConfig,
													loginBackgroundImage: "",
												},
												editCount: this.state.editCount + 1,
												editing: true,
											});
										}}
										onClick={(e) => {
											this.setState({ uploadingLoginBackgroundImage: true });
										}}
									/>
									<FilesUploaderModal
										title="Image"
										links={{
											getAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
											addAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
										}}
										isOpen={this.state.uploadingLoginBackgroundImage}
										toggle={() => {
											this.setState({
												uploadingLoginBackgroundImage: false,
											});
										}}
										orgId={this.props.orgId}
										addFiles={(fileURL) => {
											this.setState({
												appConfig: {
													...this.state.appConfig,
													loginBackgroundImage: fileURL,
												},
												editCount: this.state.editCount + 1,
												editing: true,
												uploadingLoginBackgroundImage: false,
											});
										}}
									/>
								</div>
							)}
						</div>
						<div className="p-20">
							<PagePreviewFrame
								setPreviewDimensions={({ width, height }) => {
									this.setState({
										frameWidth: width,
										frameHeight: height,
									});
								}}
								ref={(el) => (this.preview = el)}
								editing={this.state.editCount}
								saving={this.state.saving}
								ENV={ENV}
								renderURL={this.state.renderURL}
								focusedComponent={""}
								pageProperties={{}}
								simulatedUser={{ value: attendees[0].id }}
								simulatedSession={{}}
								postData={{
									appConfiguration: {
										...this.state.appConfig,
										defaultScreen: this.state.focusedPage,
									},
								}}
							/>
						</div>
					</div>
				);
			case 2:
				let orgFonts = this.props.org.branding.fonts || [];
				let eventFonts = this.props.event.branding.fonts || [];

				// Create an array of orgFont names for quick lookup
				const orgFontNames = orgFonts.map((font) => font.name);
				// Filter eventFonts to exclude duplicates
				let uniqueEventFonts = eventFonts.filter(
					(eventFont) => !orgFontNames.includes(eventFont.name)
				);
				// Combine orgFonts and uniqueEventFonts
				let allUniqueFonts = [...orgFonts, ...uniqueEventFonts];
				const fontOptions = allUniqueFonts.map((f) => {
					return { label: f.name, value: f.name };
				});
				return (
					<div className="flex h-100 mobileConfig">
						<div className="sectionBlock">
							<h2 className="blockHeader">Color Options</h2>
							<div className="blockBody">
								<ColorField
									label="Brand Color"
									value={appConfig.brandColor}
									type="color"
									useHex={true}
									disabled={readOnly}
									required={true}
									errorTrigger={requiredFields.brandColor}
									onChange={(e) => {
										this.setState({
											appConfig: { ...appConfig, brandColor: e },
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
								/>

								{/* <ColorField
									label="Link Color"
									value={appConfig.linkColor}
									type="color"
									useHex={true}
									disabled={readOnly}
									required={true}
									errorTrigger={requiredFields.linkColor}
									onChange={(e) => {
										this.setState({
											appConfig: { ...appConfig, linkColor: e },
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
								/> */}

								<ColorField
									label="Button Text Color"
									value={appConfig.buttonTextColor}
									type="color"
									useHex={true}
									disabled={readOnly}
									required={true}
									errorTrigger={requiredFields.buttonTextColor}
									onChange={(e) => {
										this.setState({
											appConfig: { ...appConfig, buttonTextColor: e },
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
								/>
							</div>
							<h2 className="blockHeader">Fonts Options</h2>
							<div className="blockBody">
								<SelectField
									label="Headings"
									options={fontOptions}
									value={fontOptions.find(
										(f) => f.value === appConfig.headingFamily
									)}
									onChange={(e) => {
										this.setState({
											appConfig: { ...appConfig, headingFamily: e.value },
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
								/>

								<SelectField
									label="Subheadings"
									options={fontOptions}
									value={fontOptions.find(
										(f) => f.value === appConfig.subheadingFamily
									)}
									onChange={(e) => {
										this.setState({
											appConfig: { ...appConfig, subheadingFamily: e.value },
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
								/>

								<SelectField
									label="Body"
									options={fontOptions}
									value={fontOptions.find(
										(f) => f.value === appConfig.bodyFamily
									)}
									onChange={(e) => {
										this.setState({
											appConfig: { ...appConfig, bodyFamily: e.value },
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
								/>

								<SelectField
									label="Buttons"
									options={fontOptions}
									value={fontOptions.find(
										(f) => f.value === appConfig.buttonFamily
									)}
									onChange={(e) => {
										this.setState({
											appConfig: { ...appConfig, buttonFamily: e.value },
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
								/>
							</div>
							<h2 className="blockHeader">Style Options</h2>
							<div className="blockBody">
								<SelectField
									label="Corner Style"
									options={[
										{ label: "Sharp", value: "sharp" },
										{ label: "Rounded", value: "rounded" },
									]}
									value={
										appConfig.cornerStyle === "rounded"
											? {
												label: "Rounded",
												value: "rounded",
											}
											: {
												label: "Sharp",
												value: "sharp",
											}
									}
									onChange={(e) => {
										this.setState({
											appConfig: { ...appConfig, cornerStyle: e.value },
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
								/>
								<SelectField
									label="Button Font Style"
									options={[
										{ label: "Capitalized", value: "capitalize" },
										{ label: "UPPERCASE", value: "uppercase" },
									]}
									value={
										appConfig.buttonFontStyle === "uppercase"
											? {
												label: "UPPERCASE",
												value: "uppercase",
											}
											: {
												label: "Capitalized",
												value: "capitalize",
											}
									}
									onChange={(e) => {
										this.setState({
											appConfig: { ...appConfig, buttonFontStyle: e.value },
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
								/>

								<SelectField
									label="Card Style"
									options={[
										{ label: "Flat", value: "flat" },
										{ label: "Raised", value: "raised" },
									]}
									value={
										appConfig.cardStyle === "raised"
											? {
												label: "Raised",
												value: "raised",
											}
											: {
												label: "Flat",
												value: "flat",
											}
									}
									onChange={(e) => {
										this.setState({
											appConfig: { ...appConfig, cardStyle: e.value },
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
								/>
							</div>
						</div>
						<div className="p-20">
							<PagePreviewFrame
								setPreviewDimensions={({ width, height }) => {
									this.setState({
										frameWidth: width,
										frameHeight: height,
									});
								}}
								ref={(el) => (this.preview = el)}
								editing={this.state.editCount}
								saving={this.state.saving}
								ENV={ENV}
								renderURL={this.state.renderURL}
								focusedComponent={""}
								pageProperties={{}}
								simulatedUser={{ value: attendees[0].id }}
								simulatedSession={{}}
								postData={{
									appConfiguration: {
										...this.state.appConfig,
									},
								}}
							/>
						</div>
					</div>
				);
			case 3:
				return (
					<div className="flex h-100 mobileConfig posRel">
						<div className="sectionBlock">
							<h2 className="blockHeader">Application Details</h2>
							<InputField
								label="Name"
								value={appConfig.name}
								disabled={readOnly}
								required={true}
								errorTrigger={requiredFields.name}
								onChange={(e) => {
									this.setState({
										appConfig: { ...appConfig, name: e.target.value },
										editing: true,
									});
								}}
							/>
							<InputField
								label="Short Name"
								value={appConfig.shortName}
								disabled={readOnly}
								required={true}
								errorTrigger={requiredFields.shortName}
								onChange={(e) => {
									this.setState({
										appConfig: { ...appConfig, shortName: e.target.value },
										editing: true,
									});
								}}
							/>

							<InputField
								label="Description"
								value={appConfig.description}
								disabled={readOnly}
								required={true}
								errorTrigger={requiredFields.description}
								onChange={(e) => {
									this.setState({
										appConfig: { ...appConfig, description: e.target.value },
										editing: true,
									});
								}}
							/>
							<ColorField
								label="Background Color"
								value={appConfig.backgroundColor}
								type="color"
								useHex={true}
								disabled={readOnly}
								required={true}
								errorTrigger={requiredFields.backgroundColor}
								onChange={(e) => {
									this.setState({
										appConfig: { ...appConfig, backgroundColor: e },
										editing: true,
									});
								}}
							/>

							<ColorField
								label="Theme Color"
								value={appConfig.themeColor}
								type="color"
								useHex={true}
								disabled={readOnly}
								required={true}
								errorTrigger={requiredFields.themeColor}
								onChange={(e) => {
									this.setState({
										appConfig: { ...appConfig, themeColor: e },
										editing: true,
									});
								}}
							/>
							<TextAreaField
								label="Installation Prompt Message"
								value={appConfig.installationPrompt}
								disabled={readOnly}
								required={true}
								errorTrigger={requiredFields.installationPrompt}
								onChange={(e) => {
									this.setState({
										appConfig: {
											...appConfig,
											installationPrompt: e.target.value,
										},
										editing: true,
									});
								}}
							/>
							<h2 className="blockHeader">Application Icons</h2>

							<div className="flex aic gap20">
								<FileUploadInputBox
									label="Small (128x128)"
									onClick={() => {
										this.setState({
											uploadingAppIcon: "small",
										});
									}}
									value={appConfig.icons.small}
									clearFile={() => {
										this.setState({
											appConfig: {
												...appConfig,
												icons: {
													...appConfig.icons,
													small: "",
												},
											},
											uploadingAppIcon: "",
											editing: true,
										});
									}}
									addText="Icon"
								/>
								<FileUploadInputBox
									label="Medium (256x256)"
									onClick={() => {
										this.setState({
											uploadingAppIcon: "medium",
										});
									}}
									value={appConfig.icons.medium}
									clearFile={() => {
										this.setState({
											appConfig: {
												...appConfig,
												icons: {
													...appConfig.icons,
													medium: "",
												},
											},
											editing: true,
											uploadingAppIcon: "",
										});
									}}
									addText="Icon"
								/>
								<FileUploadInputBox
									label="Large (512x512)"
									onClick={() => {
										this.setState({
											uploadingAppIcon: "large",
										});
									}}
									value={appConfig.icons.large}
									clearFile={() => {
										this.setState({
											appConfig: {
												...appConfig,
												icons: {
													...appConfig.icons,
													large: "",
												},
											},
											editing: true,
											uploadingAppIcon: "",
										});
									}}
									addText="Icon"
								/>
							</div>
							{this.state.uploadingAppIcon !== "" && <FilesUploaderModal
								title="Icon"
								isOpen={this.state.uploadingAppIcon !== ""}
								toggle={() => {
									this.setState({
										uploadingAppIcon: "",
									});
								}}
								eventId={this.props.eventId}
								links={{
									getAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
									addAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
								}}
								orgId={this.props.orgId}
								addFiles={(fileURL) => {
									this.setState({
										appConfig: {
											...appConfig,
											icons: {
												...appConfig.icons,
												[this.state.uploadingAppIcon]: fileURL,
											},
										},
										editing: true,
										uploadingAppIcon: "",
									});
								}}
							/>}

							<h2 className="blockHeader">Application Splash Screens</h2>
							<div className="flex aic gap20" style={{ minHeight: 300 }}>
								<FileUploadInputBox
									label="Splash Screen (1242x2208)"
									classes="tall"
									onClick={() => {
										this.setState({
											uploadingSplashImage: "large",
										});
									}}
									value={appConfig.splashScreens.large}
									clearFile={() => {
										this.setState({
											appConfig: {
												...appConfig,
												splashScreens: {
													...appConfig.splashScreens,
													large: "",
												},
											},
											editing: true,
										});
									}}
									addText="Splash screen"
								/>
							</div>

							<FilesUploaderModal
								title="Splash Screen"
								isOpen={this.state.uploadingSplashImage !== ""}
								toggle={() => {
									this.setState({
										uploadingSplashImage: "",
									});
								}}
								eventId={this.props.eventId}
								links={{
									getAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
									addAssets: `Organizations/${this.props.orgId}/events/${this.props.eventId}/assets`,
								}}
								orgId={this.props.orgId}
								addFiles={(fileURL) => {
									this.setState({
										appConfig: {
											...appConfig,
											splashScreens: {
												...appConfig.splashScreens,
												[this.state.uploadingSplashImage]: fileURL,
											},
										},
										editing: true,
										uploadingSplashImage: "",
									});
								}}
							/>
						</div>

						<div className="p-20">
							<PagePreviewFrame
								setPreviewDimensions={({ width, height }) => {
									this.setState({
										frameWidth: width,
										frameHeight: height,
									});
								}}
								ref={(el) => (this.preview = el)}
								editing={this.state.editCount}
								saving={this.state.saving}
								ENV={ENV}
								renderURL={this.state.renderURL}
								focusedComponent={""}
								pageProperties={{}}
								simulatedUser={{ value: attendees[0].id }}
								simulatedSession={{}}
								postData={{
									appConfiguration: this.state.appConfig,
								}}
							/>
						</div>
					</div>
				);
			case 4:
				const {
					brandColor,
					buttonTextColor,
					name,
					shortName,
					description,
					backgroundColor,
					themeColor,
					installationPrompt,
					enabled
				} = this.props.event.appConfiguration;
				const configurationComplete =
					name !== "" &&
					shortName !== "" &&
					description !== "" &&
					backgroundColor !== "" &&
					themeColor !== "" &&
					installationPrompt !== "";
				const customizationComplete =
					brandColor !== "" && buttonTextColor !== "";

				return (
					<div className="flex h-100 mobileConfig">
						<div className="sectionBlock mt-20">
							<div className="outlineCard">
								<p className="mb-20">
									This guide will walk you through the quick and easy process of deploying your event app to attendees. No need to publish to an app store—your app is a web-based solution that allows attendees to install directly on their mobile devices. We've designed this to be straightforward, so you can focus on what matters most: creating an awesome event experience.
								</p>
								<ToggleField
									label={<strong>Get started by enabling the app</strong>}
									icons={false}
									checked={appConfig.enabled}
									disabled={!configurationComplete || !customizationComplete}
									onChange={(val) => {
										this.setState({
											appConfig: {
												...appConfig,
												enabled: val.target.checked,
											},
											editCount: this.state.editCount + 1,
											editing: true,
										});
									}}
								/>
								{configurationComplete && customizationComplete ? null : (
									<div>
										<p className="mt-20 modalErrorMessage small">
											It appears that the application setup is incomplete.
											Please return to Customize or Configure settings and
											finalize the necessary setup before enabling the
											application.
										</p>
									</div>
								)}

								<div
									className={`mt-10 flex aic gap5 ${customizationComplete ? "blue" : "neu"}`}
								>
									{customizationComplete ? <i
										className={`las la-check-circle`}
									></i> : <i className=" las la-times-circle"></i>}
									<p className={`small`}>
										Customize
									</p>
								</div>
								<div
									className={`mt-10 flex aic gap5 ${configurationComplete ? "blue" : "neu"}`}
								>
									{configurationComplete ? <i
										className={`las la-check-circle`}
									></i> : <i className=" las la-times-circle"></i>}
									<p className={`small`}>
										Configure
									</p>
								</div>
							</div>
							{enabled && <>
								<div>
									<h2 className="blockHeader">Share with your Attendees</h2>
									<div
										className={`flex aic gap10`}
									>
										<InputField
											label="Send this link to your attendees for app installation."
											required={false}
											disabled={true}
											placeholder={`${this.props.event.nameSlug}/App`}
											value={this.props.org.hostname ?
												`https://${this.props.org.hostname}/${this.props.event.nameSlug}/App` :
												`https://${this.props.org.identifier}.simple.events/${this.props.event.nameSlug}/App`
											}
											readOnly
										/>
										<button className={`neu ${this.state.linkCopied ? 'disabled' : ''}`} onClick={this.handleCopyEventLink}>
											{this.state.linkCopied ? 'Link Copied' : `Copy link`}
										</button>
									</div>
								</div>
								<div>
									<h2 className="blockHeader">App Installation Instructions</h2>
									<p className="mb-20">
										Help your attendees install the app with this simple guide.
										Copy the guide to your clipboard and paste it along with your
										app link.
									</p>
								</div>
								<button className={`neu mt-20 ${this.state.guideCopied ? 'disabled' : ''}`} onClick={this.handleCopyGuide}>
									{this.state.guideCopied ? `Link Copied` : `Copy Guide to Clipboard`}
								</button>
								<div>
									<h1 className="sectionName mt-20"><i className="lab la-apple mr-10"></i>For iOS Devices</h1>
									<p className="mt-10">1. Open the event link in Safari</p>
									<p className="mt-10">
										2. Tap the Share button (square with an arrow)
									</p>
									<p className="mt-10">
										3. Scroll and select "Add to Home Screen"
									</p>
									<p className="mt-10">4. Name the app (if desired)</p>
									<p className="mt-10">5. Tap "Add"</p>
									<p className="mt-10">
										6. The app icon will now appear on your home screen
									</p>
									<h2 className="blockHeader">Troubleshooting</h2>
									<ul>
										<li className="mt-10">Ensure you're using Safari</li>
										<li className="mt-10">Check that your iOS is up to date</li>
										<li className="mt-10">Close and reopen Safari if needed</li>
										<li className="mt-10">
											Verify you have sufficient device storage
										</li>
									</ul>
								</div>
								<div>
									<h1 className="sectionName mt-20"><i className="lab la-android mr-10"></i>For Android Devices</h1>
									<p className="mt-10">
										1. Open the event link in your mobile browser{" "}
									</p>
									<p className="mt-10">
										2. Tap the "Add to Home Screen" button in the browser menu
									</p>
									<p className="mt-10">
										3. Tap "Add" or "Install" in the pop-up window
									</p>
									<p className="mt-10">
										4. The app icon will now appear on your home screen
									</p>
									<h2 className="blockHeader">Troubleshooting</h2>
									<ul>
										<li className="mt-10">
											If no prompt appears, look for the browser's menu (three dots)
										</li>
										<li className="mt-10">
											Select "Add to Home Screen" from the menu
										</li>
										<li className="mt-10">
											Ensure you have enough storage space
										</li>
										<li className="mt-10">
											Restart your browser if installation fails
										</li>
									</ul>
								</div>
							</>}
						</div>
					</div>
				);
			default:
				return <div />;
		}
	};

	updateSelected = (index) => {
		this.setState({ selectedSection: index });
	};

	handleJoyrideCallback = (data) => {
		const { status } = data;
		const finishedStatuses = ['finished', 'skipped'];
		if (finishedStatuses.includes(status)) {
			this.setState({ runPageTutorial: false });
		}
	};

	startTour = () => {
		this.setState({ runPageTutorial: true });
	};

	render() {
		const { editing, selectedSection, runPageTutorial } = this.state;
		const { event } = this.props;
		return (
			<div className="sectionContainer">
				<Joyride
					callback={this.handleJoyrideCallback}
					continuous
					run={runPageTutorial}
					scrollOffset={64}
					scrollToFirstStep
					showProgress={false}
					hideCloseButton={false}
					showSkipButton
					steps={tutorials['Mobile']}
					styles={{
						buttonNext: {
							background: 'var(--primary)',
							border: 'var(--primary--border)',
							color: 'var(--white)',
							fontWeight: 600,
							padding: '10px 15px',
							fontSize: 14,
							width: 65,
							height: 30,
						},
						buttonSkip: {
							background: 'var()',
							border: 'var(--primary--border)',
							color: 'var(--primary)',
							fontWeight: 600,
							padding: '10px 15px',
							fontSize: 14,
						},
						buttonBack: {
							color: "#007bff",
						},

					}}
				/>
				<SectionHeader
					title={"Mobile App"}
					breadcrumbs={[
						{
							name: event.name,
						},
					]}
				/>
				<TabsContainer
					tabs={[
						{ title: "Setup" },
						{ title: "Build" },
						{ title: "Customize" },
						{ title: "Configure" },
						{ title: "Deploy" },
					]}
					updateSelected={this.updateSelected}
					selectedIndex={selectedSection}
				/>

				<div className="sectionBody">{this.renderSection()}</div>

				<SectionFooter
					updatedAt={event.updatedAt}
					cancelEdit={this.cancelEdit}
					saveEdit={this.saveInfo}
					editing={editing}
					lastEditedBy={this.state.appConfig.lastEditedBy}
				/>
			</div>
		);
	}
}

export default ApplicationSetup;
